import { QRCodeSVG } from "qrcode.react";

export const SiteQr = ({ size = 96 }) => (
  <span className="inline-block rounded-xl border border-line bg-white p-2.5 shadow-sm" data-testid="qr-code">
    <QRCodeSVG value={window.location.origin} size={size} fgColor="#0f172a" bgColor="#ffffff" level="M" />
  </span>
);
